var map = {
	"./adult/de/3 01 Tulleord Intro.mp3": 795,
	"./adult/nn/3 01 Tulleord Intro.mp3": 796,
	"./adult/no/3 01 Tulleord Intro.mp3": 797,
	"./youth/de/3 01 Tulleord Intro.mp3": 798,
	"./youth/nn/3 01 Tulleord Intro.mp3": 799,
	"./youth/no/3 01 Tulleord Intro.mp3": 800,
	"./youth/se/3 01 Tulleord Intro.mp3": 801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;